import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Label.module.scss';

const Label = ({ htmlFor, hasError, inline, children, className, suffix }) => (
  <label
    htmlFor={htmlFor}
    className={cn(
      styles.label,
      { [styles.error]: hasError, error: hasError, [styles.inline]: inline },
      className
    )}
  >
    {children}
    {suffix && (
      <small>{`(${suffix})`}</small>
    )}
  </label>
);

Label.propTypes = {
  htmlFor: PropTypes.string,
  hasError: PropTypes.bool,
  inline: PropTypes.bool,
  className: PropTypes.string,
  suffix: PropTypes.string,
};

Label.defaultProps = {
  htmlFor: null,
  hasError: false,
  inline: false,
  className: null,
  suffix: null,
};

export default Label;
